import React from "react";
import { Col, Row } from "react-bootstrap";
import { DisplayBox } from "../components";
import { AffiliateSettingInterface, ApiHelper, ArrayHelper, CommissionRowInterface } from "../helpers";
import { CommissionChecks } from "./components";
import { Affiliates } from "./components/Affiliates";
import { Commissions } from "./components/Commissions";

interface Props {
}

export const AffiliatePage: React.FC<Props> = props => {

  const [affiliateSettings, setAffiliateSettings] = React.useState<AffiliateSettingInterface[]>(null);
  const [allCommissions, setAllCommissions] = React.useState<CommissionRowInterface[]>(null);

  const init = React.useCallback(async () => {
    const data = await ApiHelper.get<AffiliateSettingInterface[]>("/affiliateSettings") || [];
    if (data.length > 0) {
      setAffiliateSettings(data);
      ApiHelper.get<any[]>("/affiliateSettings/commissions/withCode").then((d) => {
        d?.forEach((c: any) => {

          if (c.referredByCode && ArrayHelper.getOne(data, "code", c.referredByCode) === null) c.referredByCode = null;
        });
        setAllCommissions(d || [])
      });
    }
  }, []);

  React.useEffect(() => { init() }, [init])

  const getLinks = () => {
    if (affiliateSettings?.length > 0) {
      const url = "https://signpresenter.com/?code=" + affiliateSettings[0].code;
      const churchUrl = "https://church.signpresenter.com/?code=" + affiliateSettings[0].code;
      return (<>
        <p>Your affiliate links:<br />
          <a href={url} target="_blank" rel="noreferrer" >{url}</a><br />
          <a href={churchUrl} target="_blank" rel="noreferrer">{churchUrl}</a>
        </p>
      </>);
    }
  }

  const getAffiliates = () => {
    const result: React.ReactElement[] = [];
    affiliateSettings?.forEach(s => {
      result.push(<Affiliates affiliateSetting={s} />)
    });
    return result;
  }

  const getCommissions = () => {
    const result: React.ReactElement[] = [];
    for (let s of affiliateSettings || []) {
      if (allCommissions) {
        let first = true;
        const commissions: CommissionRowInterface[] = ArrayHelper.getAllArray(allCommissions || [], "referredByCode", (first) ? [s.code, null, ""] : [s.code]);;
        result.push(<Commissions affiliateSetting={s} commissions={commissions} />)
        first = false;
      }
    }

    return result;
  }


  return (
    <div className="page-container">
      <div className="page-header">
        <h1><i className="fas fa-money-bill-wave"></i> Affiliate</h1>
      </div>
      {getLinks()}
      <Row>
        <Col>
          <DisplayBox headerIcon="fas fa-money-bill-wave" headerText="Current Affiliates">
            {getAffiliates()}
          </DisplayBox>
        </Col>
        <Col>
          <DisplayBox headerIcon="fas fa-money-bill-wave" headerText="Commission Checks">
            <CommissionChecks />
          </DisplayBox>

          <DisplayBox headerIcon="fas fa-money-bill-wave" headerText="Current Commissions">
            {getCommissions()}
          </DisplayBox>
        </Col>
      </Row>
    </div>
  );
};